import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Maintenance } from './pages/Maintenance';
import { Facilities } from './pages/Facilities';
import { Parcels } from './pages/Parcels';
import { Visitors } from './pages/Visitors';
import { Payments, PaymentSuccess, PaymentCancel } from './pages/Payments';
import { Users } from './pages/Users';
import { Properties } from './pages/Properties';
import { Invoices } from './pages/Invoices';
import { PrepareBills } from './pages/PrepareBills';
import { Statements } from './pages/Statements';
import { PendingApprovals } from './pages/PendingApprovals';
import { Announcements } from './pages/Announcements';
import { Reports } from './pages/Reports';
import { WaterTariff } from './pages/WaterTariff';
import { Polls } from './pages/Polls';
import { Chat } from './pages/Chat';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Public registration is disabled - only admin creates accounts */}
          <Route path="/register" element={<Navigate to="/login" replace />} />
          
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="payments" element={<Payments />} />
            <Route path="facilities" element={<Facilities />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="parcels" element={<Parcels />} />
            <Route path="visitors" element={<Visitors />} />
            <Route path="users" element={<ProtectedRoute allowedRoles={['management']}><Users /></ProtectedRoute>} />
            <Route path="properties" element={<ProtectedRoute allowedRoles={['management']}><Properties /></ProtectedRoute>} />
            <Route path="invoices" element={<Invoices view="list" />} />
            <Route path="prepare-bills" element={<ProtectedRoute allowedRoles={['management']}><PrepareBills /></ProtectedRoute>} />
            <Route path="statements" element={<ProtectedRoute allowedRoles={['management']}><Statements /></ProtectedRoute>} />
            <Route path="payment-approvals" element={<ProtectedRoute allowedRoles={['management']}><PendingApprovals /></ProtectedRoute>} />
            <Route path="announcements" element={<Announcements />} />
            <Route path="polls" element={<Polls />} />
            <Route path="chat" element={<Chat />} />
            <Route path="reports" element={<ProtectedRoute allowedRoles={['management', 'owner']}><Reports /></ProtectedRoute>} />
            <Route path="water-tariff" element={<ProtectedRoute allowedRoles={['management']}><WaterTariff /></ProtectedRoute>} />
          </Route>

          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />

          <Route path="/unauthorized" element={<div className="min-h-screen flex items-center justify-center"><p>Unauthorized Access</p></div>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
